/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Einvoice_Invoice_Date_AdjustedInputs */

const vi_einvoice_invoice_date_adjusted = /** @type {(inputs: Einvoice_Invoice_Date_AdjustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ngày hóa đơn đã cập nhật thành ${i?.date} (ngày phát hành) theo quy định MISA`)
};

/**

* @param {Einvoice_Invoice_Date_AdjustedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_invoice_date_adjusted = /** @type {((inputs: Einvoice_Invoice_Date_AdjustedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Invoice_Date_AdjustedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_invoice_date_adjusted(inputs)
});